<template>
  <main id="home" class="page-container" v-if="$route.path === '/home'">
    <div id="square">
      <router-link to="/home/clients" class="router-link-reset">
        <div id="customers" class="square">
          <img src="@/assets/Group_57.png" alt="customer" class="home_icons" />
          <p>Clienti</p>
        </div>
      </router-link>
      <router-link to="/home/quotes" class="router-link-reset">
        <div id="quotes" class="square">
          <img src="@/assets/budget.png" alt="budget" class="home_icons" />
          <p>Preventivi</p>
        </div>
      </router-link>
      <router-link to="/home/stock" class="router-link-reset">
        <div id="items" class="square">
          <img src="@/assets/ready-stock.png" alt="stock" class="home_icons" />
          <p>Magazzino</p>
        </div>
      </router-link>
      <router-link to="/home/operators" class="router-link-reset">
        <div id="operators" class="square">
          <img src="@/assets/operator.png" alt="operator" class="home_icons" />
          <p>Operatori</p>
        </div>
      </router-link>
    </div>
  </main>
  <router-view></router-view>
</template>

<script>
export default {
  name: "HomePage",
  data() {
    return {};
  },
  methods: {},
};
</script>

import "
<style src="@/css/HomePage.css"></style>
